var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 315 316",
    style: {
      enableBackground: "new 0 0 315 316"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4c4c4"
    },
    d: "M34 114h182v137H34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M34 114h26v137H34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fb00"
    },
    d: "M60 114h26v137H60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#02feff"
    },
    d: "M86 114h26v137H86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#01ff00"
    },
    d: "M112 114h26v137h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fd00fb"
    },
    d: "M138 114h26v137h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fb0102"
    },
    d: "M164 114h26v137h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0301fc"
    },
    d: "M190 114h26v137h-26z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 157.5,
    y1: 318,
    x2: 157.5,
    y2: 2,
    gradientTransform: "matrix(1 0 0 -1 0 318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cceacb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6bc6f8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 86.1v192.5c0 3.9 2.6 6.6 6.6 6.6h25.8l6 25.6c1.3 3.3 4 5.3 6.6 5.3h31.8c3.3 0 6-2 6.6-5.3l6-25.6h135l6 25.6c.7 2.6 3.3 5.3 6.6 5.3h33c3.3 0 6-2 6.6-5.3l6-25.6h25.8c4 0 6.6-2.6 6.6-6.6V86.1c0-3.9-2.6-6.6-6.6-6.6h-139c-2-15.8-13.9-28.3-29.1-30.9L178 11.2c2.6-2.6 2.6-6.6 0-9.2-2.6-2.6-6.6-2.6-9.3 0L125 45.4 81.4 2c-2.6-2.6-6.6-2.6-9.3 0-2.6 2.6-2.6 6.6 0 9.2l37.7 37.4c-15.2 2.6-27.1 15.1-29.1 30.9H6.6c-3.3 0-6.6 3.3-6.6 6.6zm72.1 216.8H50.3l-4-17.1h29.8l-4 17.1zm192.6 0h-21.8l-4-17.1h29.8l-4 17.1zM115.8 61.8h18.5c10.6 0 19.9 7.9 21.8 18.4H94c2-10.6 11.2-18.4 21.8-18.4zM13.2 92.6h288.5V272H13.2V92.6zm184.7 8.6H52.3c-17.2 0-31.1 13.8-31.1 30.9v101.8c0 17.1 13.9 30.9 31.1 30.9h144.9c17.2 0 31.1-13.8 31.1-30.9V132c0-17-13.9-30.8-30.4-30.8zm17.2 132c0 9.9-7.9 17.7-17.9 17.7H52.3c-9.9 0-17.9-7.9-17.9-17.7V132c0-9.9 7.9-17.7 17.9-17.7h144.9c9.9 0 17.9 7.9 17.9 17.7v101.2zm32.4-132h31.8c4 0 6.6 3.3 6.6 6.6v31.5c0 3.9-2.6 6.6-6.6 6.6h-31.8c-4 0-6.6-2.6-6.6-6.6v-31.5c0-4 2.6-6.6 6.6-6.6zm6.6 31.5h18.5v-18.4h-18.5v18.4zm25.2 32.2h-31.8c-4 0-6.6 2.6-6.6 6.6V203c0 3.9 2.6 6.6 6.6 6.6h31.8c4 0 6.6-2.6 6.6-6.6v-31.5c0-4-2.7-6.6-6.6-6.6zm-6.7 30.9h-18.5V178h18.5v17.8zm-25.1 44.6h31.8c4 0 6.6 2.6 6.6 6.6 0 3.9-2.6 6.6-6.6 6.6h-31.8c-4 0-6.6-2.6-6.6-6.6s2.6-6.6 6.6-6.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#a)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.a3aff016d46b1197eae615725ae89d45.svg";
export { ForwardRef as ReactComponent };